// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DollarCircleFilledSvg from "@fishx/icons-svg/es/asn/DollarCircleFilled";
import FishxIcon from '../components/FishxIcon';

var DollarCircleFilled = function DollarCircleFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DollarCircleFilledSvg
  }));
};

DollarCircleFilled.displayName = 'DollarCircleFilled';
export default React.forwardRef(DollarCircleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DollarCircleFilled.js
// module id = 2433
// module chunks = 0